import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  border=radius: 4px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  max-width: 1120px;
  margin: 0 auto;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

const ImgWrapper = styled.div`
  display: inline-block;
  position: relative;
  overflow: hidden;
  height: 160px;
  max-height: 50vw;
  @supports (display: flex) {
    flex: 1;
  }

  @media (min-width: 320px) {
    flex: 1;
    height: auto;
    min-height: 45vh;
    max-height: 100%;

    @supports (display: flex) {
      min-height: auto;
    }
  }
`

const Excerpt = styled.p`
  margin: 0 1rem 1rem 1rem;
  line-height: 1.6;
`
const FeaturedCardImg = styled.img`
  width: 100%;
  height: 100%;
  flex: 1;

  @supports (object-fit: cover) {
    object-fit: cover;
`

const Text = styled.div`
  @supports (display: flex) {
    flex: 1;
  }
  padding: 10px;

  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    margin: 34px 0;
    padding: 48px;
    max-width: 50%;
  }
`

const FeaturedCardTitle = styled.p`
  display: flex;
  font-size: 34px;
  padding-left: 16px;
  margin-bottom: 10px;
  font-weight: 600;
`

const VideoWrapper = styled.div`
  display: block;
  position: relative;
`

const Iframe = styled.iframe`
  max-width: 100%;
  width: 100%;
  padding: 10px;

  @media (min-width: 768px) {
    position: absolute;
    top: 0;
    left: 0;
    width: 600px;
    height: 100%;
    max-width: 560px;
    border: none;
  }
`
const FeaturedCard = ({ title, children, image, videoLink }) => {
  return (
    <Wrapper>
      <Text>
        <div>{children}</div>
      </Text>
      {image && !videoLink && (
        <ImgWrapper>
          <FeaturedCardImg alt={title || ''} src={image} />
        </ImgWrapper>
      )}
      {videoLink && (
        <VideoWrapper>
          <Iframe
            src={`https://www.youtube.com/embed/${videoLink}? rel=0`}
            frameBorder="0"
            allowfullscreen
          />
        </VideoWrapper>
      )}
    </Wrapper>
  )
}

FeaturedCard.PropTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  descriptions: PropTypes.string,
  videoLink: PropTypes.string,
  children: PropTypes.node,
}

export default FeaturedCard
